import { ApolloError } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { MembershipOfferFragment } from '@occc/graphql';
import { IPaginationProps } from '@occc-app/hooks/usePaginatedQuery';
import { getOfferComponentType } from '@occc-app/offerHelpers/utils';
import { createRouteCreator } from '@occc-app/routes/CampaignComponents/utils';
import { DataTable, DataTableHeader, MakeTableFields, Row } from '@occc/ui-design-system';

export type InProgressOffersTableProps = {
  offers?: MembershipOfferFragment[];
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
  headers: DataTableHeader[];
  makeFields: MakeTableFields<MembershipOfferFragment>;
};

export const InProgressOffersTable = ({
  offers,
  loading,
  error,
  paginationProps,
  headers,
  makeFields,
}: InProgressOffersTableProps) => {
  const navigate = useNavigate();

  const rows: Row[] | null | undefined = offers?.map((offer) => {
    const fields = makeFields(offer);
    const onClick = () => {
      const offerType = getOfferComponentType(offer);

      if (offerType && offer.campaign) {
        const routeCreator = createRouteCreator(offerType);
        navigate(routeCreator.details(offer.campaign.uuid, offer.id));
      }
    };

    return {
      key: offer.id,
      fields,
      onClick,
    };
  });

  return (
    <DataTable
      headers={headers}
      rows={rows}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
    />
  );
};
